import { ExperienceTemplateRenderer, TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';

interface ListViewLayoutTemplateComponent extends TemplateComponent {
  config: {
    reverse: boolean;
  };
}

export interface ListViewLayoutProps extends TemplateComponentProps {
  templateComponent: ListViewLayoutTemplateComponent;
}

export const ListViewLayout: React.FC<ListViewLayoutProps> = ({
  templateComponent: {
    children,
    config: { reverse },
  },
}) => {
  if (!children) return null;

  return (
    <Viewport>
      <ViewLarge>
        <UitkLayoutFlex direction={reverse ? 'row-reverse' : 'row'}>
          <ExperienceTemplateRenderer templateComponents={children} />
        </UitkLayoutFlex>
      </ViewLarge>
      <ViewSmall>
        <UitkLayoutFlex direction="column">
          <ExperienceTemplateRenderer templateComponents={children} />
        </UitkLayoutFlex>
      </ViewSmall>
    </Viewport>
  );
};
